import { passkeyQueryKeys as e } from "./usePasskeyQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { usersApi as n } from "@maat/api-main";
//#region src/passkeys/usePasskeysQuery.ts
var r = (r = !0) => {
	let i = t({
		queryKey: e.list(),
		queryFn: () => n.passkeys(),
		enabled: r,
		retry: !1
	});
	return {
		...i,
		passkeys: i.data?.passkeys ?? []
	};
};
//#endregion
export { r as usePasskeysQuery };
